import { messageConstants } from "../actions/constants";

const initialState = { messages: [], loading: false };

const messageReducer = (state = initialState, action) => {
    switch (action.type) {
        case messageConstants.GET_MESSAGES_REQUEST:
            return { ...state, loading: true };

        case messageConstants.GET_MESSAGES_SUCCESS:
            return { ...state, messages: action.payload.messages, loading: false };

        case messageConstants.GET_MESSAGES_FAILURE:
            return { ...state, loading: false };

        case messageConstants.CLEAR_MESSAGES:
            return { ...state, messages: [] };

        // добавление новых (любой из трёх типов + приём по сокету)
        case messageConstants.SEND_TEXT_SUCCESS:
        case messageConstants.SEND_FILE_SUCCESS:
        case messageConstants.SEND_VOICE_SUCCESS:
        case messageConstants.RECEIVE_NEW_MESSAGE: {
            const msg = action.payload.message;
            const exists = state.messages.some((m) => m._id === msg._id);
            return exists ? state : { ...state, messages: [...state.messages, msg] };
        }

        case messageConstants.MARK_MESSAGES_AS_READ_SUCCESS: {
            const { chatId, userId } = action.payload;
            return {
                ...state,
                messages: state.messages.map((msg) => {
                    const senderId = msg.sender?._id || msg.sender;
                    if (String(msg.chatId) !== String(chatId) || String(senderId) === String(userId)) return msg;
                    const already = (msg.readBy || []).some((u) => String(u?._id || u) === String(userId));
                    return already ? msg : { ...msg, readBy: [...(msg.readBy || []), userId] };
                }),
            };
        }

        case messageConstants.DELETE_MESSAGE_SUCCESS: {
            const { messageId } = action.payload;
            return { ...state, messages: state.messages.filter((m) => m._id !== messageId) };
        }

        default:
            return state;
    }
};

export default messageReducer;
